import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  userRole:string;
  selectedMenu: string;
  constructor(private _localStorageService: LocalstorageService, private router: Router) {
    this.userRole = LocalstorageService.getUserRole();
    this.selectedMenu = _localStorageService.getMenu();
  }

  selectMenu(selectedMenu:string) {    
    this.selectedMenu = selectedMenu;
    this._localStorageService.setMenu(selectedMenu);
  }

  shopNow() {
    this.router.navigate(['/home-page']);
    this._localStorageService.removeMenu();
  }

  ngOnInit() {
    
  }
}
